<template>
  <el-drawer
    direction="ttb"
    class="share_box_content"
    :model-value="modelValue"
    :destroy-on-close="true"
    :before-close="handleClose"
  >
    <div
      v-loading="ctrl.down"
      class="share_list"
    >
      <swiper
        class="swiper"
        :modules="modules"
        :pagination="true"
        :effect="'coverflow'"
        :grab-cursor="true"
        :centered-slides="true"
        :slides-per-view="'auto'"
        :coverflow-effect="{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }"
        @swiper="setSwiperRef"
      >
        <swiper-slide
          v-for="(item, index) in opts.shareList"
          :key="item.id"
          class="slide"
          @click="toSwiper(index)"
        >
          <div class="share_item">
            <div
              :ref="setItemRef"
              class="share_box"
              :style="{ backgroundImage: `url(${item.picUrl})` }"
              :data-is="item.id"
            >
              <div
                v-if="token"
                class="share_user_info"
              >
                <div class="cover_user">
                  <div
                    :style="{ backgroundImage: `url(${userInfo.headImg})` }"
                    class="user_border_img"
                  />
                </div>
                <div class="share_user_name tx-ov">
                  {{ userInfo.nickname }}
                </div>
              </div>
              <div class="share_product">
                <img
                  class="share_cover"
                  :src="map.courseCoverBase64 || info.courseCover"
                >
                <div class="share_product_title tx-ov-2">
                  {{ info[key] }}
                </div>
                <div class="share_price">
                  {{ info.price > 0 ? "￥" + info.price.toFixed(2) : "免费" }}
                </div>
              </div>
              <div class="share_code">
                <qr-code-vue
                  v-if="shareUrl"
                  :id="`share_code_img_${item.id}`"
                  data-etype="image"
                  class="share_code_img"
                  :margin="4"
                  :value="shareUrl"
                  :size="100"
                />
                <div class="share_code_msg">
                  <div class="share_code_text">
                    长按识别二维码
                  </div>
                  <div class="share_code_course">
                    查看该课程
                  </div>
                  <div class="share_code_shop">
                    来自「{{ shopInfo.shopName }}」
                  </div>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="btn_list">
        <el-button
          type="primary"
          @click="handleSaveDown()"
        >
          保存图片
        </el-button>
        <el-button @click.native="handleCopyText">
          复制网址
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import {
  computed,
  defineComponent,
  reactive,
  watch,
  onBeforeUpdate,
  onUpdated,
  nextTick, ref
} from 'vue'
import { useUserStore } from '../../stores/user'
import { shopAuthPicList, shopPicList } from '../../api/course'
import QrCodeVue from 'qrcode.vue'
import html2canvas from 'html2canvas'
import { ElMessage } from 'element-plus'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { EffectCoverflow } from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/effect-coverflow'
export default defineComponent({
  name: 'Share',
  components: {
    QrCodeVue,
    Swiper,
    SwiperSlide
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: function () {
        return {}
      }
    },
    key: {
      type: String,
      default: 'courseName'
    }
  },
  setup (props, { emit }) {
    const { getToken, getUserView, getShopInfo } = useUserStore()
    const { modelValue, info } = toRefs(props);
    console.log(info.value);
    // 因为分享组件在课程播放页面也有使用的 所以不能直接读取浏览器url 会分享课程学习页面出去
    const courseTypeEnum = {
      1: '/course/live', // '直播课',
      2: '/course/video', // '视频课',
      3: '/course/audio', // '音频课',
      4: '/course/graphic', // '图文课',
      5: '/course/subject', // '专题课',
      6: '/course/topic' // '套餐',
    }
    const shareUrl = computed(() => {
      return `${window.location.origin}${courseTypeEnum[info.value.courseType]}?id=${info.value.id}`
    })
    const token = computed(() => {
      return getToken()
    })
    const userInfo = ref(null)
    const shopInfo = ref(null)
    const getShop = async () => {
      // 获取资料（平台、用户）
      shopInfo.value = await getShopInfo()
      if (token.value) {
        userInfo.value = await getUserView()
      }
    }
    const ctrl = reactive({
      loading: false,
      code: true,
      down: false
    })
    const map = reactive({
      menuKey: '',
      routerPath: '',
      courseCoverBase64: ''
    })
    const opts = reactive({
      shareList: []
    })
    let itemRefs = []
    const setItemRef = (el) => {
      // ref
      if (el) {
        itemRefs.push(el)
      }
    }
    const getInfo = () => {
      // 获取分享图
      if (token.value) {
        shopAuthPicList().then((res) => {
          opts.shareList = res
        }).catch(() => {
          getInfo()
        })
      } else {
        shopPicList().then((res) => {
          opts.shareList = res
        })
      }
    }
    const handleClose = () => {
      // 关闭弹窗
      emit('update:modelValue', false)
    }
    const handleCopyText = () => {
      // 复制文本
      const text = shareUrl.value
      const tag = document.createElement('textarea')
      tag.setAttribute('id', 'cp_hgz_input')
      tag.value = text
      document.body.appendChild(tag)
      document.getElementById('cp_hgz_input').select()
      document.execCommand('copy', true)
      document.getElementById('cp_hgz_input').remove()

      if (window.navigator.clipboard) {
        window.navigator.clipboard.writeText(text)
      }
      ElMessage.success('复制成功')
    }
    const handleSaveDown = () => {
      const obj = itemRefs[swiperRef.activeIndex]
      if (obj !== null) {
        html2canvas(obj, {
          useCORS: true,
          logging: true,
          x: 0,
          y: 0,
          scale: 1,
          width: 340,
          height: 604
        }).then((canvas) => {
          const url = canvas.toDataURL() // 这里上面不设值cors会报错
          const a = document.createElement('a') // 创建一个a标签 用来下载
          a.download = info.value[props.key] // 设置下载的图片名称
          const event = new MouseEvent('click') // 增加一个点击事件
          // 如果需要下载的话就加上这两句
          a.href = url // 此处的url为base64格式的图片资源
          a.dispatchEvent(event) // 触发a的单击事件 即可完成下载
          ctrl.down = false
        }).catch(err => {
          console.error(err)
        })
      }
    }
    watch(() => modelValue.value, (val) => {
      if (val) {
        map.menuKey = ''
        opts.shareList = []
        itemRefs = []
        getInfo()
      }
    })

    watch(() => info.value, (val) => {
      if (val && val.courseCover) {
        const img = new Image()
        img.src = val.courseCover
        img.setAttribute('crossOrigin', 'Anonymous')
        img.onload = function () {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, img.width, img.height)
          const dataURL = canvas.toDataURL('image/png')
          map.courseCoverBase64 = dataURL
        }
      }
    }, { immediate: true })
    onBeforeUpdate(() => {
      itemRefs = []
    })
    onUpdated(() => {
      getShop()
    })

    const modules = [EffectCoverflow]
    let swiperRef = null
    const setSwiperRef = (swiper) => {
      swiperRef = swiper
      swiperRef.activeIndex = 1
    }

    const toSwiper = (index) => {
      if (index != swiperRef.activeIndex) {
        swiperRef.slideTo(index)
      }
    }
    return {
      map,
      opts,
      userInfo,
      token,
      shopInfo,
      shareUrl,
      ctrl,
      modules,
      setSwiperRef,
      ...toRefs(props),
      itemRefs,
      toSwiper,
      setItemRef,
      handleClose,
      handleSaveDown,
      handleCopyText
    }
  }
})
</script>
<style lang="scss">
.share_box_content {
  position: relative;
  .el-drawer__header {
    padding: 0;
    margin-bottom: 0px;
    height: 0px;
  }
  .el-drawer__body {
    padding: 0;
    padding-top: calc((100vh - 744px) / 2);
  }
  .el-drawer__close-btn {
    position: absolute;
    top: calc((100vh - 744px) / 2  + 20px) ;
    z-index: 10;
    right: calc((100vw - 1200px) / 2 - 60px)
  }
}

</style>

<style scoped lang="scss">
.coverflow-example {
  position: relative;
}

.share_code_img {
  margin:-10px 0 0 -10px
}

.swiper {
  height: 624px;
  width: 100%;
  padding-top: 20px;
  &:deep(.swiper-slide-shadow-left)  {
    left: 60px;
    width: 340px;
    border-radius:10px;
    background-image: linear-gradient(270deg,rgba(0,0,0,.5),rgba(0,0,0,.1));
  }

  &:deep(.swiper-slide-shadow-right) {
    left: 60px;
    width: 340px;
    border-radius: 10px;
    background-image: linear-gradient(90deg,rgba(0,0,0,.5),rgba(0,0,0,.1))
  }

  .slide {
    width: 460px;
    text-align: center;
    height: 604px;
  }
}

.btn_list .el-button {
  width: 160px;
  height: 40px;
}
.btn_list {
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
  justify-content: center;
  align-items: center;
}
.share_list {
  height: 684px;
  overflow: hidden;
  width: 1200px;
  position: relative;
  .share_item {
    width: 340px;
    display: inline-block;
    position: relative;
    user-select:none;
  }
  .share_item + .share_item {
    margin-left: 20px;
  }
  .share_box {
    width: 340px;
    height: 604px;
    position: relative;
    background-size: 100% 100%;
    border-radius: 10px;
    padding: 20px;
  }
  .share_user_info {
    width: calc(100% - 40px);
    color: #ffffff;
  }
  .share_product {
    background-color: #ffffff;
    border-radius: 5px;
    padding: 10px;
    width: calc(100% - 40px);
    position: absolute;
    bottom: 130px;
  }
  .share_product_title {
    font-style: normal;
    font-weight: 550;
    font-size: 18px;
    color: #333333;
    margin-top: 5px;
    margin-bottom: 5px;
    height: 52px;
  }
  .share_price {
    font-style: normal;
    font-weight: 550;
    font-size: 20px;
    color: #ff0000;
  }
  .share_cover {
    height: 158px;
    width: 280px;
    border-radius: 5px;
    object-fit: cover;
  }
  .share_code {
    width: calc(100% - 40px);
    height: 100px;
    position: absolute;
    bottom: 20px;
    background-color: #ffffff;
    border-radius: 5px;
    padding: 10px;
    display: flex;
  }
  .share_code_msg {
    margin-left: 10px;
  }
  .share_code_text {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }
  .share_code_course {
    font-style: normal;
    font-weight: 550;
    font-size: 16px;
    color: #333333;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .share_code_shop {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    color: #becadb;
  }
  .share_user_info {
    position: relative;
  }

  .copy_box {
    width: 100%;
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    border-radius: 5px;
  }
  .copy_text {
    width: calc(100% - 60px);
    padding-left: 10px;
  }
  .copy_btn {
    width: 60px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    cursor: pointer;
    &:hover {
      color: #2256f6;
    }
  }
}
.user_border_img {
  border: 2px solid #ffffff;
  width: 40px;
  height: 40px;
  border-radius: 100px;
  margin-right: 5px;
  background-size: 100% 100%;
}
.cover_user {
  display: inline-block;
}
.share_user_name {
  display: inline-block;
  font-style: normal;
  font-weight: 550;
  font-size: 20px;
  width: calc(100% - 50px);
  padding-bottom: 6px;
  padding-top: 6px;
}
</style>
